import { isEqual } from 'lodash'
import { useCallback, useState } from 'react'
import type {
  AddMedicationFields,
  AddMedicationFormState
} from '../AddMedicationScreen/addMedicationForm'

/**
 * The facelift page's add medication form. Local to the page, so leaving it
 * discards whatever was entered and the next visit starts empty. Same shape as
 * the V1 modal's redux form, so the save and the medication picker can be
 * shared as plain functions.
 */
export const useAddMedicationForm = (residentId: string) => {
  const [initialFields] = useState<AddMedicationFields>(() => ({
    resident: residentId
  }))
  const [fields, setFields] = useState(initialFields)
  const [formState, setFormStateValues] = useState<AddMedicationFormState>({})

  const setField = useCallback(
    <Key extends keyof AddMedicationFields>(
      key: Key,
      value: AddMedicationFields[Key]
    ) => setFields((current) => ({ ...current, [key]: value })),
    []
  )

  const setFormState = useCallback(
    <Key extends keyof AddMedicationFormState>(
      key: Key,
      value: AddMedicationFormState[Key]
    ) => setFormStateValues((current) => ({ ...current, [key]: value })),
    []
  )

  return {
    fields,
    formState,
    /** Whether any field differs from how the form started. */
    isDirty: !isEqual(fields, initialFields),
    setField,
    setFormState
  }
}
